// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3jh_n","buttons":"Footer_buttons__34g_O"};